import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';

//TODO: redirect to email-validation if user is pending
const PublicRoute = ({ component: Component, appState, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            return !appState.auth ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: '/quotes',
                        state: {
                            from: props.location
                        }
                    }}
                />
            );
        }}
    />
);
export default PublicRoute;



// WEBPACK FOOTER //
// ./src/modules/router/PublicRoute.jsx